import { TaskFilterOptions } from '@griply/types';
import { filterRepeatingTasks, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

import { useRepeatingTasks } from '../use-repeating-tasks';

export const useFilteredRepeatingTasks = (
  filters: TaskFilterOptions | TaskFilterOptions[],
) => {
  const today = useToday();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);
  const repeatingTasks = useRepeatingTasks();

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    return filterRepeatingTasks({
      repeatingTasks,
      filters: filtersArray,
      weekStartsOn,
      today,
    });
  }, [filters, repeatingTasks, today, weekStartsOn]);
};
